import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { ComponentProps, FC } from 'react'

const { RangePicker } = DatePicker

type Props = {
  onFilter: (periodFrom: string, periodTo: string) => void
  value?: [string, string]
} & Omit<ComponentProps<typeof RangePicker>, 'value'>

const DateFilter: FC<Props> = ({ onFilter, value, ...props }) => {
  const [periodFrom, periodTo] = value || []

  const onChangeHandler = (dates: [Dayjs, Dayjs]) => {
    const [periodFrom, periodTo] = dates || []
    onFilter(periodFrom?.toISOString(), periodTo?.toISOString())
  }
  return (
    <RangePicker
      allowClear={true}
      format="MM.YYYY"
      onChange={onChangeHandler}
      picker="month"
      value={[periodFrom && dayjs(periodFrom), periodTo && dayjs(periodTo)]}
      {...props}
    />
  )
}

export default DateFilter
